import $ from 'jquery';
import Pixelzoom from 'pixelzoom';
import layout from '../Layout';

export default class ProductZoom {
  constructor(options) {
    this.$gallery = options.$gallery;
    this.settings = options.settings;
    this.$slider = this.$gallery.find('[data-product-slider]');

    this.$pixelzoomOverlay = this.$gallery.find('[data-pixelzoom-overlay]');
    this.$pixelzoomOverlayContainer = this.$pixelzoomOverlay.find('[data-pixelzoom-overlay-container]');

    this.imageZoom = {};
    this.zoomOverlay = null;
    this.index = 0;

    this._beforeOpen = this._beforeOpen.bind(this);
    this._onOpen = this._onOpen.bind(this);
    this._onClose = this._onClose.bind(this);

    this._showZoomInstructions = this._showZoomInstructions.bind(this);

    this.modalOpen = false;
    this.swipping = false;
    this.touched = false;

    this._bindEvents();
    this.enableZoom();
  }

  unload() {
    if (Object.keys(this.imageZoom).length !== 0) {
      Object.keys(this.imageZoom).forEach(image => {
        this.imageZoom[image].unload();
      });

      this.imageZoom = {};
    }

    if (this.zoomOverlay) {
      this.zoomOverlay.unload();
      this.zoomOverlay = null;
    }

    document.body.removeEventListener('touchmove', event => {
      event.preventDefault();
    }, { passive: false });

    this.$pixelzoomOverlayContainer.off('pixelzoom:pan');
    this.$pixelzoomOverlayContainer.off('pixelzoom:release');

    this.$slider.off('.product-zoom');
  }

  enableZoom(index) {
    if (layout.isBreakpoint('XS')) {
      this.unload();
      return;
    }

    if ((index !== -1 && index) || index === 0) {
      this.index = index;
    }

    const $newSlide = this.$slider.find(`[data-product-image-index=${this.index}] .product-galley--image-background`);
    const inObject = !this.imageZoom[this.index];
    const slideExists = this.$gallery.find(`[data-product-image-index=${this.index}][data-product-image-zoom]`).length;

    if (inObject && slideExists) {
      this.imageZoom[this.index] = new Pixelzoom($newSlide[0], {
        imageSource: $newSlide[0].dataset.image,
        initialZoom: this.settings.image_zoom_level === 'min' ? 1 : 9999,
        zoomSensitivity: 10,
        maxZoom: 9999,
        zoomSteps: 9999,
        naturalPan: true,
      });

      $newSlide.on('pixelzoom:loaded', () => {
        this._showZoomInstructions($newSlide);

        $(window).on('resize', () => {
          this._showZoomInstructions($newSlide);
        });
      });

      $newSlide.on('pixelzoom:touch', () => {
        const imageWidth = $newSlide.find('.pixelzoom--image').get(0).naturalWidth;
        const imageHeight = $newSlide.find('.pixelzoom--image').get(0).naturalHeight;

        if (!layout.isBreakpoint('XS') && (imageWidth / $newSlide.width() >= 2 || imageHeight / $newSlide.height() >= 2)) {
          this._toggleClass($('body'), 'pixelzoom--active');
        }

        this.touched = true;
      });

      $newSlide.on('pixelzoom:release', () => {
        this._toggleClass($('body'), 'pixelzoom--active', true);
        this.touched = false;
      });
    }
  }

  _showZoomInstructions($newSlide) {
    setTimeout(() => {
      if ($newSlide.css('cursor') !== 'default') {
        $newSlide.find('.product-galley--zoom-instructions').css('display', 'block');
      }
    }, 200);
  }

  _bindEvents() {
    this.$slider.on('dragStart.flickity', () => {
      this._preventClick();
    });

    this.$slider.on('settle.flickity', () => {
      this._resolveClick();
    });

    document.body.addEventListener('touchmove', event => {
      this._preventScroll(event);
    }, { passive: false });
  }

  _toggleClass(element, className, remove) {
    if (remove) {
      element.removeClass(className);
    } else {
      element.addClass(className);
    }
  }

  _beforeOpen() {
    const $newSlide = this.$slider.find(`[data-product-image-index=${this.index}] .product-galley--image-background`);

    this.$pixelzoomOverlayContainer.find('[data-rimg]').replaceWith($newSlide.find('[data-rimg]').clone());
  }

  _onOpen() {
    const $newSlide = this.$slider.find(`[data-product-image-index=${this.index}] .product-galley--image-background`);
    this.modalOpen = true;

    setTimeout(() => {
      this.zoomOverlay = new Pixelzoom(document.querySelector('[data-modal-content]'), {
        imageSource: $newSlide[0].dataset.image,
        naturalPan: true,
        dragPan: true,
        initialZoom: this.settings.image_zoom_level === 'min' ? 1 : 9999,
        maxZoom: 9999,
        zoomSensitivity: 10,
        zoomSteps: 9999,
        overflowContainer: document.querySelector('.modal--pixelzoom'),
      });

      $('[data-modal-content]').on('pixelzoom:loaded', () => {
        $('[data-modal-content]').addClass('loaded');
      });

      $('[data-modal-content]').on('pixelzoom:touch', () => {
        this._toggleClass($('body'), 'pixelzoom--active');
      });

      $('[data-modal-content]').on('pixelzoom:release', () => {
        this._toggleClass($('body'), 'pixelzoom--active', true);
      });
    }, 500);
  }

  _onClose() {
    $('[data-modal-content]').removeClass('loaded');

    this.zoomOverlay.unload();
    this.zoomOverlay = null;
    this.modalOpen = false;
  }

  _preventScroll(event) {
    if (this.modalOpen || (this.touched && !layout.isBreakpoint('XS'))) {
      event.preventDefault();
    }
  }

  _preventClick() {
    this.swipping = true;
  }

  _resolveClick() {
    this.swipping = false;
  }
}
